import { render, staticRenderFns } from "./NoteEditDesktop.vue?vue&type=template&id=0111d0fc&scoped=true&"
import script from "./NoteEditDesktop.vue?vue&type=script&lang=js&"
export * from "./NoteEditDesktop.vue?vue&type=script&lang=js&"
import style0 from "./NoteEditDesktop.vue?vue&type=style&index=0&id=0111d0fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0111d0fc",
  null
  
)

component.options.__file = "NoteEditDesktop.vue"
export default component.exports